import { UrlApi } from "../../../services/apirest";

export const getSucursales = async () => {
  const response = await fetch(`${UrlApi}/sucursales/escencial`);

  if (!response.ok) throw new Error("Error al obtener las sucursales");

  const data = await response.json();

  return data;
};

export const getCategorias = async () => {
  const response = await fetch(`${UrlApi}/categorias`);

  if (!response.ok) throw new Error("Error al obtener las categorias");

  const data = await response.json();

  return data;
};

export const getClientes = async () => {
  const response = await fetch(`${UrlApi}/clientes`);

  if (!response.ok) throw new Error("Error al obtener los clientes");

  const data = await response.json();

  return data.map((c) => ({
    id: c.id,
    razon_social: c.razon_social,
  }));
};
